import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { Pencil2Icon } from '@radix-ui/react-icons';
import { Link } from 'react-router';

import { DropdownMenuItem } from '../../primitives/dropdown-menu';

import type { JSX } from 'react';

interface DropdownMenuItemEditProps extends React.ComponentPropsWithoutRef<
  typeof DropdownMenuPrimitive.Item
> {
  icon?: JSX.Element;
  navLink?: {
    to: string;
  };
  text?: string;
}

export function DropdownMenuItemNavigate({
  icon = <Pencil2Icon className="size-4" />,
  id,
  navLink,
  text = 'Editar',
  ...props
}: DropdownMenuItemEditProps) {
  if (navLink) {
    return (
      <DropdownMenuItem asChild template="grid-icon-content">
        <Link className="rounded-3xl" id={id} to={navLink?.to}>
          <div className="flex justify-center">{icon}</div>
          <span>{text}</span>
        </Link>
      </DropdownMenuItem>
    );
  }

  return (
    <DropdownMenuItem id={id} template="grid-icon-content" {...props}>
      <div className="flex justify-center">{icon}</div>
      <span>{text}</span>
    </DropdownMenuItem>
  );
}
